import { render, staticRenderFns } from "./ProjectsShow.vue?vue&type=template&id=c7ac8edc&"
import script from "./ProjectsShow.vue?vue&type=script&lang=js&"
export * from "./ProjectsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports